export class ComponentDatasourceProvider {
    DATASOURCE_DATAS: any[]; 
    DATASOURCE_FILTERED_DATAS: any[];
    DATASOURCE_VALUE_FIELD: string; 
    DATASOURCE_DISPLAY_FIELD: string;
    DATASOURCE_COUNT_TOTAL?: number;
    DATASOURCE_PAGE_NUMBER?: number;
    DATASOURCE_TOTAL_PAGES?: number;
    DATASOURCE_PAGE_SIZE?: number;
    DATASOURCE_COLUMNS?: any[];
}

export enum COMPONENT_MODE {
    EXECUTION = 0,
    DESIGN = 1,
    CONSULTATION = 2
}

export enum COMPONENT_UI {
    IONIC = 0,
    MATERIAL = 1,
    KENDO = 2
}